import { createFileRoute, useNavigate } from "@tanstack/react-router";

import SignInForm from "@/components/sign-in-form";
import SignUpForm from "@/components/sign-up-form";
import { authSearchSchema } from "@/lib/auth-redirect";

export const Route = createFileRoute("/(auth)/login")({
  validateSearch: authSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { mode } = Route.useSearch();
  const navigate = useNavigate();

  // Switching form replaces the history entry: Back should leave /login for
  // wherever the visitor came from, not step through the two views.
  const switchTo = (next: "signin" | "signup") => {
    void navigate({
      to: "/login",
      replace: true,
      search: (prev) => ({
        ...prev,
        ...(next === "signup"
          ? { mode: "signup" as const }
          : { mode: undefined }),
      }),
    });
  };

  return mode === "signup" ? (
    <SignUpForm onSwitchToSignIn={() => switchTo("signin")} />
  ) : (
    <SignInForm onSwitchToSignUp={() => switchTo("signup")} />
  );
}
